import { Time } from "@angular/common";

export class CatFichaInmaterial {
    id: Number;
    nombre_manifestacion: string;
    nombre_representante: string;
    mh_manifestacion_herencia: string;
    mh_agno_ref_expresion_cultural: string;
    mh_titulo: string;
    mh_descripcion: string;
    mt_marco_temporal: string;
    mt_fecha_celebracion: string;
    mt_desc_obs: string;
    tm_tema: string;
    tm_desc_obs: string;
    ea_estado_actual: string;
    ea_desc_obs: string;
    tca_trasc_cultural_alcance: string;
    tca_desc_obs: string;
    roepd1_element_destacables: string;
    roepd1_desc_obs: string;
    roepd2_element_destacables: string;
    roepd2_desc_obs: string;
    roepd3_element_destacables: string;
    roepd3_desc_obs: string;
    ouc_otros_usos_costumbres: string;
    ouc_desc_obs: string;
    observaciones: string;
    coord_nombre: string;
    coord_cargo: string;
    cata1_nombre: string;
    cata1_cargo: string;
    cata2_nombre: string;
    cata2_cargo: string;
    cata3_nombre: string;
    cata3_cargo: string;
    fecha: Date;
    codregistro: string;
    ubicacion_manifestacion: string;
}